import React from 'react';
import { getDisplayName } from '../../utils/hocHelpers';

import PlaceResolver from '../placeResolver/PlaceResolver';

export default function WithPlaceResolver({ services, variant }) {
  return (WrappedComponent) => {
    const Component = (props) => (
      <PlaceResolver services={services} variant={variant}>
        {(spinProps) => <WrappedComponent {...spinProps} {...props} />}
      </PlaceResolver>
    );
    Component.displayName = `WithPlaceResolver(${getDisplayName(WrappedComponent)})`;
    return Component;
  };
}
